module.exports = __webpack_public_path__ + "static/media/life.448b10bc.svg";